import { render, staticRenderFns } from "./ApoliceSeguroIBPList.vue?vue&type=template&id=0a6766a7"
import script from "./ApoliceSeguroIBPList.vue?vue&type=script&lang=js"
export * from "./ApoliceSeguroIBPList.vue?vue&type=script&lang=js"
import style0 from "./ApoliceSeguroIBPList.vue?vue&type=style&index=0&id=0a6766a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports